<script setup lang="ts">
import type { TSortItem } from '~/layers/catalog/data/types'

import { useCatalogSort } from '~/layers/catalog/composables/catalogSort'
import { useCatalogStore } from '~/layers/catalog/store/catalog'

defineProps({
  items: {
    type: Array as PropType<TSortItem[]>,
    required: true,
  },
})

const store = useCatalogStore()
const filter = useCatalogFilter()

const isOpened = ref(true)

const toggle = () => {
  isOpened.value = !isOpened.value
}

const select = (item: TSortItem) => {
  useCatalogSort().set(item.code, item.direction)
}
</script>

<template>
  <div class="sort_mobile mb-4">
    <div
      :class="{ filters__item_open: isOpened }"
      class="filters__item"
    >
      <div
        class="filters__header"
        @click="toggle"
      >
        <div class="filters__header-row">
          <p>Сортировать</p>
        </div>
        <svg-icon
          class="filters__icon-arrow"
          height="16"
          name="down-arrow"
          width="16"
        />
      </div>

      <div class="filters__form">
        <template
          v-for="item in items"
          :key="`${item.code}:${item.direction}`"
        >
          <label
            class="filters__value"
            @click.stop="select(item)"
          >
            <input
              class="radio__input"
              type="radio"
              :value="item.code"
              :checked="
                item.code === store.sort.code &&
                item.direction === store.sort.direction
              "
            />
            <p class="radio__text">
              <template
                v-if="filter.isEnabledRuValues(item.code) && !!item.nameRu"
              >
                {{ item.nameRu }}</template
              >
              <template v-else>{{ item.name }}</template>
            </p>
          </label>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '/assets/scss/components/sort.scss' as *;
</style>
